/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { useArtifactStorageService } from 'domain/shared/artifactStorage';
import ArtifactStorageForm from 'domain/documents/artifactStorage/createupdate/ArtifactStorageForm';
import { CreateForm } from 'framework/form';
import CreateArtifactStorageBreadcrumbs from 'domain/documents/artifactStorage/createupdate/Create/Breadcrumbs';
import { useArtifactStorageUrl } from 'domain/shared/artifactStorage';

const CreateArtifact = () => {
  const { create, getValidationSchema } = useArtifactStorageService();
  const { getSingleEntityUrl } = useArtifactStorageUrl();

  const redirect = (response: any) => {
    return getSingleEntityUrl(response.id);
  };

  return (
    <CreateForm
      submitFormFunc={create}
      afterSubmit={{
        redirect,
        message: 'You are awesome! The artifact has been successfully created.',
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <CreatePageLayout title="Create: Artifact" breadcrumbs={<CreateArtifactStorageBreadcrumbs />}>
        <ArtifactStorageForm />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default CreateArtifact;
